import api from '../../api';
import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import PostForm from './PostForm';
import PostTable from './PostTable';

const Announcements = () => { //TODO rename for Post
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formDataPost, setFormDataPost] = useState({
    name: '',
    description: '',
    date: '',
    link: '',
    is_new: false
  });

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await api.get('/posts/');
      setPosts(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleInputChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormDataPost({
      ...formDataPost,
      [event.target.name]: value,
    });
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); 
    const year = today.getFullYear();
    const formattedDate = `${day}/${month}/${year}`; 
  
    const updatedFormData = { 
      ...formDataPost, 
      date: formattedDate 
    };
  
    await api.post('/posts/', updatedFormData);
    fetchPosts();
  
    setFormDataPost({
      name: '',
      description: '',
      date: '',
      link: '',
      is_new: false
    });
  };
  

  const handleDelete = async (id) => {
    try {
      await api.delete(`/posts/${id}`);
      fetchPosts();
    } catch (error) {
      console.error('Error deleting post:', error);
    }
  };

  const handleEdit = async (updatedPost) => {
    try {
      await api.put(`/posts/${updatedPost.id}`, updatedPost);
      fetchPosts();
    } catch (error) {
      console.error('Error editing post:', error);
    }
  };

  return (
    <div className="container">
      <PostForm formDataPost={formDataPost} onInputChange={handleInputChange} onSubmit={handleFormSubmit} />
      {loading ? <LoadingSpinner /> : <PostTable posts={posts} onDelete={handleDelete} onEdit={handleEdit} />}
    </div>
  );
};

export default Announcements;
